import * as Yup from "yup";
import { enqueueSnackbar } from "notistack";
import { api } from "../../services/api";
import { errorsMessage } from "../../helpers";

export function usePhotoCondominioEdit({ photo, getPhotos, handleClose }) {
  const initialValues = {
    id: photo?.Id || "",
    Descricao: photo?.Descricao || "",
    Ordem: photo?.Ordem || "0"
  };

  const validationSchema = Yup.object().shape({
    Descricao: Yup.string().required("Informe a descrição da foto"),
    Ordem: Yup.number().required("Informe a ordem da foto")
  });

  const onSubmit = async (values, { setSubmitting, setStatus, resetForm }) => {
    try {
      setSubmitting(true);

      const { id, ...formData } = values;

      await api.put(`/fotos-condominio/${id}`, formData);

      resetForm();
      enqueueSnackbar("Dados salvos com sucesso!", {
        variant: "success"
      });
      getPhotos();
      handleClose();
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
      setStatus({ success: false });
      setSubmitting(false);
    }
  };

  return {
    onSubmit,
    initialValues,
    validationSchema
  };
}
